import { render } from "./btcSalesClosed.vue?vue&type=template&id=ed6666c4&scoped=true"
import script from "./btcSalesClosed.vue?vue&type=script&lang=js"
export * from "./btcSalesClosed.vue?vue&type=script&lang=js"

import "./btcSalesClosed.vue?vue&type=style&index=0&id=ed6666c4&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed6666c4"]])

export default __exports__